"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _DataStore = require("../../../KESI2/Stores/DataStore2");

var _KesiConnect = _interopRequireDefault(require("./KesiConnect.scss"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("../Button/index.js"));

var _AlertHelper = _interopRequireWildcard(require("../../../helpers/AlertHelper"));

var _qdKesiConnectStrings = require("../Strings/qdKesiConnectStrings");

var _ConnectHelper2 = _interopRequireDefault(require("../../../helpers/ConnectHelper"));

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));

var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));

var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));

var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));

var _Table = _interopRequireDefault(require("@material-ui/core/Table"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

// TODO: put all css in scss file
var KesiConnect = /*#__PURE__*/function (_ConnectHelper) {
  (0, _inherits2["default"])(KesiConnect, _ConnectHelper);

  var _super = _createSuper(KesiConnect);

  function KesiConnect() {
    var _this;

    (0, _classCallCheck2["default"])(this, KesiConnect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showInsertCodeAlert", function () {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var buttons = [{
        label: (0, _qdKesiConnectStrings.getString)('CHECK_CONNECT_CODE'),
        callback: function callback() {
          _this.checkCode(_this.showInsertCodeAlert);
        }
      }];
      var textFields = [{
        label: (0, _qdKesiConnectStrings.getString)('CONNECT_CONNECTION_CODE'),
        style: {
          paddingBottom: '10px'
        },
        value: _this.state.codeInput,
        onChange: _this.setCodeInput,
        type: 'text'
      }];
      (0, _AlertHelper.showAlertHtmlWithTextfields)((0, _qdKesiConnectStrings.getString)('CONNECT_INSERT_TEXT'), (0, _qdKesiConnectStrings.getString)('CONNECT_INSERT_TITLE'), error, textFields, true, null, buttons);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showRemoveConnectionAlert", function () {
      var buttons = [{
        label: (0, _qdKesiConnectStrings.getString)('CONNECT_CANCEL_CONNECTION'),
        callback: _this.removeConnection,
        theme: 'dark'
      }];
      (0, _AlertHelper.showWideAlertHtml)((0, _qdKesiConnectStrings.getString)('CONNECT_CANCEL_TEXT'), (0, _qdKesiConnectStrings.getString)('CONNECT_CANCEL_TITLE'), true, buttons);
    });
    return _this;
  }

  (0, _createClass2["default"])(KesiConnect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(KesiConnect.prototype), "componentDidMount", this).call(this);
      this.props.setTitle('Kesi Connect');
    }
  }, {
    key: "goHome",
    value: function goHome() {
      _NavigationManager["default"].goHome();
    }
  }, {
    key: "renderByConnectionSatus",
    value: function renderByConnectionSatus() {
      var _this2 = this;

      if (!this.state.isOnline) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _KesiConnect["default"].lowerWrapper
        }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _qdKesiConnectStrings.getString)('CONNECT_OFFLINE')), /*#__PURE__*/_react["default"].createElement("br", null), (0, _qdKesiConnectStrings.getString)('KESICONNECT_GO_ONLINE')));
      } else if (this.connectionCode && this.state.data[_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS] && this.state.data[_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS].length > 0) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _KesiConnect["default"].lowerWrapper
        }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
          style: {
            fontWeight: 'bold',
            fontSize: '16px'
          }
        }, (0, _qdKesiConnectStrings.getString)('KESICONNECT_CODE_IS')), /*#__PURE__*/_react["default"].createElement(_index["default"], {
          className: _KesiConnect["default"].btnConnectionCode,
          theme: 'dark'
        }, this.connectionCode), /*#__PURE__*/_react["default"].createElement(_index["default"], {
          theme: 'connectCode',
          onClick: function onClick(e) {
            return _this2.showInsertCodeAlert();
          }
        }, (0, _qdKesiConnectStrings.getString)('CONNECT_CODE_ALREADY'))), /*#__PURE__*/_react["default"].createElement("p", {
          style: {
            fontSize: 'medium',
            fontWeight: 'bold',
            marginTop: '5%'
          }
        }, (0, _qdKesiConnectStrings.getString)('CONNECT_CONNECTIONS')), /*#__PURE__*/_react["default"].createElement(_Table["default"], null, /*#__PURE__*/_react["default"].createElement(_TableHead["default"], null, /*#__PURE__*/_react["default"].createElement(_TableRow["default"], null, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], null, "applicationInstanceID"), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], null, " "))), /*#__PURE__*/_react["default"].createElement(_TableBody["default"], null, this.state.data[_DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_IDS].map(function (id, index) {
          return /*#__PURE__*/_react["default"].createElement(_TableRow["default"], {
            key: index
          }, /*#__PURE__*/_react["default"].createElement(_TableCell["default"], null, id), /*#__PURE__*/_react["default"].createElement(_TableCell["default"], null, /*#__PURE__*/_react["default"].createElement(_index["default"], {
            theme: 'dark',
            onClick: function onClick() {
              return _this2.removeConnection(id);
            }
          }, (0, _qdKesiConnectStrings.getString)('CONNECT_CANCEL'))));
        }))));
      } else if (this.connectionCode) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _KesiConnect["default"].lowerWrapper
        }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
          style: {
            fontWeight: 'bold',
            fontSize: '16px'
          }
        }, (0, _qdKesiConnectStrings.getString)('KESICONNECT_CODE_IS')), /*#__PURE__*/_react["default"].createElement(_index["default"], {
          className: _KesiConnect["default"].btnConnectionCode,
          theme: 'dark'
        }, this.connectionCode), /*#__PURE__*/_react["default"].createElement(_index["default"], {
          theme: 'connectCode',
          onClick: function onClick(e) {
            return _this2.showInsertCodeAlert();
          }
        }, (0, _qdKesiConnectStrings.getString)('CONNECT_CODE_ALREADY'))));
      } else {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _KesiConnect["default"].lowerWrapper
        }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null), /*#__PURE__*/_react["default"].createElement("p", null, (0, _qdKesiConnectStrings.getString)('CONNECT_LOADING')));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _KesiConnect["default"].mainWrapper
      }, /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          color: '#0092b7',
          fontSize: 'medium',
          fontWeight: 'bold'
        }
      }, (0, _qdKesiConnectStrings.getString)('KESICONNECT_TITLE')), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _qdKesiConnectStrings.getString)('KESICONNECT_EXPLANATION_HEADER')), /*#__PURE__*/_react["default"].createElement("br", null), (0, _qdKesiConnectStrings.getString)('KESICONNECT_EXPLANATION_TEXT')), this.renderByConnectionSatus());
    }
  }]);
  return KesiConnect;
}(_ConnectHelper2["default"]);

KesiConnect.propTypes = {
  setTitle: _propTypes["default"].func.isRequired
};
var _default = KesiConnect;
exports["default"] = _default;